import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { MarkdownModule } from 'ngx-markdown';
import { ChatUiComponent } from './chat-ui.component';
import { UiModule } from '../ui.module';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { TranslationLoaderFactory } from '@monorepo/services';
import { ChartingModule } from '../charting';

@NgModule({
  imports: [
    CommonModule,
    IonicModule,
    MarkdownModule,
    UiModule,
    ChartingModule,
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: (http: HttpClient) => {
          const factory = new TranslationLoaderFactory(http);
          return factory.createForApp('ui');
        },
        deps: [HttpClient],
      },
    }),
  ],
  declarations: [ChatUiComponent],
  exports: [ChatUiComponent, MarkdownModule],
})
export class ChatUiModule {}
